import { reqGet } from './index';

// 모니터링 - 실시간 위치현황
export const fetchRealTimeLocationStatus = param => reqGet('/v3/api/common/realtime/location/list', { ...param });

// 실시간 센서 모니터링
export const fetchRealTimeSensorMonitoring = param => reqGet('/v3/api/common/sensor', { ...param });
// 센싱 타입 조회
export const fetchSensingTypes = param => reqGet('/v3/api/common/sensor/sensingTypes', { ...param });
